import React from 'react';
import './GraphBanner.css';

/**
 * Top-of-Graphs banner driven by /models/output/graphs#bannerStatus.
 *
 * Two messages, mapped from the four user states described in the
 * model-flow spec:
 *
 *   START_STREAMING 
 *   WAIT_12_HOURS  
 *
 * Renders nothing while bannerStatus is null (still loading) — the
 * page handles its own loading skeleton above.
 */
export default function GraphBanner({ status }) {
  if (!status) return null;

  const isStart = status === 'START_STREAMING';

  const title = isStart
    ? 'Start streaming to see results'
    : 'Keep recording for 12 hours';

  // Web users can't physically start a measurement — that requires the
  // sensor + phone.
  const subtitle = isStart
    ? 'Open the HRV-4 mobile app, connect your sensor, and start a measurement to generate insights.'
    : 'Your current measurement needs at least 12 hours of data before we can produce a result.';

  return (
    <div className="graph-banner">
      <div className="graph-banner__icon-wrap">
        {isStart ? (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 12h4l3-8 4 16 3-8h4" stroke="#5CB89A" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M5 22h14M5 2h14M6 22V17a6 6 0 0 1 12 0v5M6 2v5a6 6 0 0 0 12 0V2" stroke="#5CB89A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </div>
      <div className="graph-banner__copy">
        <h4 className="graph-banner__title">{title}</h4>
        <p className="graph-banner__subtitle">{subtitle}</p>
      </div>
    </div>
  );
}
